// src/redux/features/exchangeRatesApi.ts

import { api } from '../services/api';
import { normalizeBnmRates } from '../../utils/bnmRates';

export interface ExchangeRate {
  CharCode: string;
  Value: string | number;
  Name?: string;
  Nominal?: string | number;
}

export interface ExchangeRatesResponse {
  Date?: string;
  Valute?: ExchangeRate[];
  stale?: boolean;
}

export const exchangeRatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getExchangeRates: builder.query<ExchangeRatesResponse, void>({
      query: () => ({
        url: '/app/exchange-rates/',
        method: 'GET',
      }),

      transformResponse: normalizeBnmRates,

      providesTags: ['ExchangeRates'],
    }),
  }),
});

export const { useGetExchangeRatesQuery } = exchangeRatesApi;
